import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';
import {
  TApplicationReport,
  TApplicationReportActionRequest,
  TApplicationReportsForm,
  TApplicationReportsReportExcelForm,
} from '~/components/ApplicationReports/types.ts';

export const applicationReport = createAsyncThunk<
  TApplicationReport,
  { form: TApplicationReportsForm }
>('identification/applicationReport', async ({ form }, { rejectWithValue }) => {
  try {
    const response = await api.get(`/identification/application/report`, {
      params: form,
    });

    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const getApplicationReportExcel = createAsyncThunk<
  TApplicationReportsReportExcelForm,
  { form: TApplicationReportsReportExcelForm }
>('identification/applicationReportsReportExcelForm', async ({ form }, { rejectWithValue }) => {
  try {
    const response = await api.get(`/identification/application/report/export`, {
      params: form,
    });

    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});

export const archiveApplicationReport = createAsyncThunk<null, TApplicationReportActionRequest>(
  'identification/archiveApplicationReport',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      await api.post(`/identification/application/${applicationId}/archive`);

      return null;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const restoreApplicationReport = createAsyncThunk<null, TApplicationReportActionRequest>(
  'identification/restoreApplicationReport',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      await api.post(`/identification/application/${applicationId}/restore`);

      return null;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);

export const verificationApplicationReport = createAsyncThunk<
  null,
  TApplicationReportActionRequest
>(
  'identification/verificationApplicationReport',
  async ({ applicationId }, { rejectWithValue }) => {
    try {
      await api.delete(`/identification/application/${applicationId}/verification`);

      return null;
    } catch (error) {
      return thunkErrorHandler(error, rejectWithValue);
    }
  }
);
